<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Reboot</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Reboot">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-body pb-1">
              <div class="row">
                <button type="submit" class="btn">
                  {{ isSubmit ? "Please Wait..." : "Click here to reboot" }}
                </button>
                <!-- <div class="col-md-6">
                  <div class="form-group required">
                    <label class="control-label">Audra</label>
                    <multiselect
                      v-model="accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";

export default {
  name: "RebootForm",
  metaInfo: {
    title: "Reboot | Dotlines",
  },
  components: {},
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    isSubmit: false,
    params: {},
    accountId: "",
    pre: {
      audraName: [],
    },
  }),

  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.isSubmit = true;
          _this.$swal
            .fire({
              title: "Are you sure you want to reboot audra?",
              text: "",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Reboot",
            })
            .then((result) => {
              if (result.isConfirmed) {
                _this.isSubmit = true;
                axios
                  .post("/addReboot", {
                    accountId: LocalStorage.get("accountId"),
                  })
                  .then((response) => {
                    _this.$toaster.success(response.data.message);
                  })
                  .catch((error) => {
                    console.log(error);
                    _this.$swal.fire("Failed!", "Failed to reboot.", "error");
                  })
                  .finally(() => {
                    _this.isSubmit = false;
                  });
              } else if (result.dismiss === _this.$swal.DismissReason.cancel) {
                _this.isSubmit = false;
              }
            });
        }
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
